import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createContext, useCallback, useMemo } from "react";
import { apiGet, apiPost } from './api-client'
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext(undefined);

function AuthProvider({ children }) {
  const navigate = useNavigate()
  const queryClient = useQueryClient();

  const { data, isPending: sessionPending } = useQuery({
    queryKey: ['session'],
    queryFn: () => apiGet('user/session'),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  const user = data?.status ? data.data?.data : null;
  const session = data?.status ? data.data?.session : null;

  const logout = useCallback(async () => {
    try {
      await apiPost('user/logout');
    } catch (e) {
      // ignore - cookie will be cleared server-side
    }
    queryClient.clear();
    navigate('/login')
  }, [queryClient]);

  const refreshSession = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['session'] });
  }, [queryClient]);

  const value = useMemo(() => ({
    user,
    session,
    isAuthenticated: !!user,
    logout,
    refreshSession,
  }), [user, session, logout, refreshSession]);

  if (sessionPending)
    return null;

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
